import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { login } from "../../api/authService";
import { useToast } from "../atoms/Toast";
// import logo from "../../logo.svg";

const LoginForm = ({ onLogin }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
  const { token } = await login(email, password);
  toast?.success?.('Logged in');
  onLogin(token);
  navigate('/');
    } catch (err) {
      setError(err.message || "Login failed");
      toast?.error?.(err.message || 'Login failed');
    } finally {
      setLoading(false);
    }
  };

  // Google login handler placeholder
  const handleGoogleLogin = () => {
    alert("Google login not implemented yet.");
  };

  return (
    <div className="flex flex-col min-h-screen justify-between">
      <div className="flex-1 flex items-center justify-center">
        <form
          onSubmit={handleSubmit}
          className="mx-auto w-full max-w-md p-8 bg-white rounded-xl shadow-lg flex flex-col items-center"
        >
          <img src="/logo.svg" alt="ModStack" className="h-16 w-auto" />
          <h1 className="text-2xl font-bold mb-1 text-center">
            Log in to your account
          </h1>
          <p className="text-gray-500 mb-6 text-center">
            Welcome back! Please enter your details.
          </p>
          {error && (
            <div className="text-red-600 text-sm mb-2 w-full text-center">
              {error}
            </div>
          )}
          <div className="w-full mb-4">
            <label className="block mb-1 font-medium">Email</label>
            <input
              type="email"
              className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-400"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              required
            />
          </div>
          <div className="w-full mb-2">
            <label className="block mb-1 font-medium">Password</label>
            <input
              type="password"
              className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-purple-400"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="********"
              required
            />
          </div>
          <div className="w-full flex items-center justify-between mb-6">
            <label className="flex items-center text-sm">
              <input
                type="checkbox"
                className="mr-2 accent-purple-600"
                checked={remember}
                onChange={(e) => setRemember(e.target.checked)}
              />
              Remember for 30 days
            </label>
            <button type="button" className="text-purple-600 text-sm hover:underline">
              Forgot password
            </button>
          </div>
          <button
            type="submit"
            className="w-full bg-purple-600 text-white py-2 rounded-lg font-semibold hover:bg-purple-700 transition disabled:opacity-50 mb-3"
            disabled={loading}
          >
            {loading ? "Signing in..." : "Sign in"}
          </button>
          <button
            type="button"
            onClick={handleGoogleLogin}
            className="w-full flex items-center justify-center border border-gray-300 py-2 rounded-lg font-medium text-gray-700 bg-white hover:bg-gray-50 transition mb-4"
          >
            <svg className="w-5 h-5 mr-2" viewBox="0 0 48 48">
              <g>
                <path
                  fill="#4285F4"
                  d="M24 9.5c3.54 0 6.7 1.22 9.19 3.23l6.85-6.85C36.68 2.36 30.77 0 24 0 14.82 0 6.71 5.48 2.69 13.44l7.98 6.2C12.13 13.13 17.57 9.5 24 9.5z"
                />
                <path
                  fill="#34A853"
                  d="M46.1 24.55c0-1.64-.15-3.22-.42-4.74H24v9.01h12.42c-.54 2.9-2.18 5.36-4.65 7.04l7.18 5.59C43.98 37.13 46.1 31.36 46.1 24.55z"
                />
                <path
                  fill="#FBBC05"
                  d="M10.67 28.13a14.5 14.5 0 010-8.26l-7.98-6.2A23.94 23.94 0 000 24c0 3.77.9 7.34 2.69 10.56l7.98-6.43z"
                />
                <path
                  fill="#EA4335"
                  d="M24 48c6.48 0 11.93-2.15 15.9-5.86l-7.18-5.59c-2.01 1.35-4.6 2.15-8.72 2.15-6.43 0-11.87-3.63-13.33-8.87l-7.98 6.43C6.71 42.52 14.82 48 24 48z"
                />
              </g>
            </svg>
            Sign in with Google
          </button>
          <div className="text-center text-sm text-gray-600">
            Don&apos;t have an account?{" "}
            <a href="/register" className="text-purple-600 hover:underline">
              Sign up
            </a>
          </div>
        </form>
      </div>
      <footer className="w-full text-center text-xs text-gray-400 py-6 flex flex-col gap-2">
        <div>
          &copy; 2025 ModStack &nbsp; &bull; &nbsp;
          <button type="button" className="hover:underline">
            Privacy Policy
          </button>{" "}
          &nbsp; &bull; &nbsp;
          <button type="button" className="hover:underline">
            Terms of Service
          </button>
        </div>
      </footer>
    </div>
  );
};

export default LoginForm;
